<template>
  <div>
    <div id="header-wrapper">
			<div class="header">
				<h1>Notification</h1>
			</div>
		</div>
    <!--Content-->
		<div id="content">
      <div class="tabs">
        <span class="tabs-banners" :class="notiType === 'banner' ? 'selected' : ''" @click="notiType = 'banner'" >Banners</span>
        <span class="tabs-flags" :class="notiType === 'flag' ? 'selected' : ''" @click="notiType = 'flag'">Flag messages</span>
        <span class="tabs-inlines" :class="notiType === 'inline' ? 'selected' : ''" @click="notiType = 'inline'">Inline messages</span>
      </div>
      <div v-show="notiType === 'banner'">
        <notifcation-banner />
      </div>
      <div v-show="notiType === 'flag'">
        <notifcation-flag />
      </div>
      <div v-show="notiType === 'inline'">
        <notifcation-inline />
      </div>
		</div><!--//#content-->
  </div>
</template>

<script>
import notifcationBanner from './NotificationBanner'
import notifcationFlag from './NotificationFlag'
import notifcationInline from './NotificationInline'

export default {
  name: 'notification-page',
  props: [],
  components: {
    notifcationBanner: notifcationBanner,
    notifcationFlag: notifcationFlag,
    notifcationInline: notifcationInline,
  },
  data () {
    return {
      notiType: 'banner',
    }
  },
  computed: {

  },

  methods: {

  },

  mounted() {
    let type = 'error'
    //this.$notiFlag('message', 'title', {type: 'warning'})

  }
}
</script>
<style lang="scss" scoped>
@import "../plugins/mtui/styles/Variables.scss";
.tabs {
  margin-top: 47px;
  span {
    padding-bottom: 4px;
    margin-right: 49px;
    cursor: pointer;
  }
  span.selected {
    border-bottom: 2px solid $c-primary;
  }
}

</style>




// WEBPACK FOOTER //
// Notification.vue?5d6b2e4d